export const STATUS_STYLES = {
  draft: "text-gray-600 border-gray-400 bg-gray-50",
  new: "text-amber-700 border-amber-500 bg-amber-50",
  quoted: "text-blue-700 border-blue-500 bg-blue-50",
  converted: "text-emerald-700 border-emerald-600 bg-emerald-50",
  lost: "text-red-700 border-red-500 bg-red-50",
  confirmed: "text-emerald-700 border-emerald-600 bg-emerald-50",
  dispatched: "text-blue-700 border-blue-600 bg-blue-50",
  completed: "text-green-700 border-green-600 bg-green-50",
  cancelled: "text-red-700 border-red-600 bg-red-50",
  active: "text-emerald-700 border-emerald-600 bg-emerald-50",
  maintenance: "text-amber-700 border-amber-500 bg-amber-50",
  deployed: "text-blue-700 border-blue-600 bg-blue-50",
  verified: "text-emerald-700 border-emerald-600 bg-emerald-50",
  pending: "text-amber-700 border-amber-500 bg-amber-50",
  expired: "text-red-700 border-red-600 bg-red-50",
  sent: "text-blue-700 border-blue-500 bg-blue-50",
  declined: "text-red-700 border-red-500 bg-red-50",
  preparing: "text-amber-700 border-amber-500 bg-amber-50",
  ready: "text-emerald-700 border-emerald-600 bg-emerald-50",
  paid: "text-emerald-700 border-emerald-600 bg-emerald-50",
  unpaid: "text-amber-700 border-amber-500 bg-amber-50",
};

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || STATUS_STYLES.draft;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-[0.15em] ${cls}`}
    >
      {status}
    </span>
  );
}

export const fmt = (n) =>
  `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function QuoteLines({ quote }) {
  if (!quote) return null;
  const rows = [
    { label: "Base package", value: quote.base_package, testid: "quote-base" },
    { label: quote.menu_name ? `Catering — ${quote.menu_name} · ${quote.guests} × ${fmt(quote.per_head)}` : `Catering — ${quote.guests} guests × ${fmt(quote.per_head)}`, value: quote.per_head_total, testid: "quote-catering" },
    { label: `Travel — ${quote.travel_miles} mi each way (round-trip charge)`, value: quote.travel_fee, testid: "quote-travel" },
    { label: "External providers", value: quote.providers_total, testid: "quote-providers" },
  ];
  return (
    <div data-testid="quote-breakdown" className="border border-border bg-white">
      {rows.map((r) => (
        <div key={r.testid} className="flex items-center justify-between border-b border-border px-4 py-2.5 text-sm">
          <span className="text-muted-foreground">{r.label}</span>
          <span data-testid={r.testid} className="font-medium tabular-nums">{fmt(r.value)}</span>
        </div>
      ))}
      <div className="flex items-center justify-between border-b border-border px-4 py-2.5">
        <span className="font-heading text-sm font-bold uppercase tracking-wide">Total</span>
        <span data-testid="quote-total" className="font-heading text-base font-bold tabular-nums">{fmt(quote.total)}</span>
      </div>
      <div className="flex items-center justify-between bg-emerald-50 px-4 py-2.5">
        <span className="text-sm font-semibold text-emerald-800">Deposit due (25%)</span>
        <span data-testid="quote-deposit" className="font-heading text-base font-bold text-emerald-700 tabular-nums">{fmt(quote.deposit)}</span>
      </div>
    </div>
  );
}
